import styled from '@emotion/styled'

import { TYPOGRAPHY_12 } from 'theme/theme'

const ErrorText = styled.div`
  ${TYPOGRAPHY_12}

  color: #bb002f;
  margin-top: 4px;
`

export default ErrorText
